/**
 * 验证身份证号码
 */
export function validateIdCard(rule, value, callback) {
  if (!value) {
    return callback(new Error('请输入身份证号码'))
  }

  // 简单的身份证验证规则
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  if (reg.test(value) === false) {
    callback(new Error('身份证格式不正确'))
  } else {
    callback()
  }
}

/**
 * 验证手机号码
 */
export function validatePhone(rule, value, callback) {
  if (!value) {
    return callback();
  }

  const reg = /^1[3-9]\d{9}$/
  if (reg.test(value) === false) {
    callback(new Error('手机号码格式不正确'))
  } else {
    callback()
  }
}

/**
 * 验证邮政编码
 */
export function validatePostalCode(rule, value, callback) {
  if (!value) {
    return callback()
  }

  const reg = /^[0-9]{6}$/
  if (reg.test(value) === false) {
    callback(new Error('邮政编码必须是6位数字'))
  } else {
    callback()
  }
}

/**
 * 银行卡号基础校验
 */
export function validateBankCardBasic(rule, value, callback) {
  if (!value) return callback();

  const reg = /^\d{16,19}$/
  if (reg.test(value) === false) {
    callback(new Error('银行卡号应为16-19位数字'))
  } else {
    callback()
  }
}



// WEBPACK FOOTER //
// ./src/utils/validate.js